import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"

/* Icons */
import { SearchIcon, CloseIcon, CalendarIcon, StarIcon, FilterIcon, RefreshIcon, PlayerIcon, OperatorIcon, CheckIcon } from "./Icons"
import { LoadingOutlined } from "@ant-design/icons"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ruLocale from "date-fns/locale/ru"
import enLocale from "date-fns/locale/en-US"

/* DatePicker Settings */
registerLocale("ru", ruLocale)
registerLocale("en", enLocale)


/* THE START OF A DAY SOME DAYS AGO */
const from = (days = 0) => {

    const date = new Date()

    date.setDate(date.getDate() - days)
    date.setHours(0, 0, 0, 0)

    return date
}

/* THE END OF TODAY */
const to = () => {

    const date = new Date()

    date.setHours(23, 59, 59, 0)

    return date
}

/* THE PERIODS EVERY GAME LIST IS READ BY */
const PRESETS = [
    { key: "today", text: () => t("filter.today"), range: () => ({ start: from(0), end: to() }) },
    { key: "week", text: () => t("filter.week"), range: () => ({ start: from(6), end: to() }) },
    { key: "month", text: () => t("filter.month"), range: () => ({ start: from(29), end: to() }) },
]

/* ONE DAY OF TWO DATES IS THE SAME DAY */
const sameDay = (first, second) => moment(first).format("YYYY-MM-DD") === moment(second).format("YYYY-MM-DD")

/* THE PRESET A RANGE BELONGS TO, null WHEN IT BELONGS TO NONE OF THEM */
const getPreset = (start, end) => {

    /* Send Result */
    return PRESETS.find((item) => {

        /* Fields */
        const range = item.range()

        return sameDay(range.start, start) && sameDay(range.end, end)
    }) || null
}


/*
    Component GameFilter — ONE FILTER BAR FOR THE ROUND LIST OF EVERY GAME

    number, onNumber      the round number, the search runs on submit
    player, onPlayer      the code of a player, the field appears only with the callback
    saved, onSaved        only the saved rounds, the chip appears only with the callback
    start, end            the open period
    operators             the operators of an electron game, the section appears only with a list
    onFilter              the period and the operators of the modal, applied by its own button only
    submit                every search of the number lands here
    status, reload        the state of the list and its reload
*/
class GameFilter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,

            /* The draft of the modal — nothing leaves it until the button is pressed */
            start: null,
            end: null,
            operators: [],
        }
    }

    /* Open Action — the modal always starts from what the list is showing right now */
    open = () => {

        /* Fields */
        const { start, end, operators } = this.props

        this.setState({
            visible: true,
            start,
            end,
            operators: Array.isArray(operators) ? operators.map((item) => ({ ...item })) : [],
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Apply Action — the whole draft leaves at once */
    apply = () => {

        /* Fields */
        const { onFilter, operators } = this.props
        const { start, end } = this.state

        /* Prepare The Patch — the names are the ones every game list keeps in its state */
        const patch = { startDate: start, endDate: end }

        /* Operators — only an electron game has them */
        if (Array.isArray(operators) && operators.length > 0) {
            patch.operators = this.state.operators
        }

        this.close()

        onFilter(patch)
    }

    /* Apply A Preset To The Draft */
    setPreset = (item) => {

        /* Fields */
        const range = item.range()

        this.setState({ start: range.start, end: range.end })
    }

    /* Toggle One Operator Of The Draft — the last one is never turned off */
    toggleOperator = (index) => {

        /* Fields */
        const { operators } = this.state

        /* Fields */
        const list = operators.map((item, position) => position === index ? { ...item, checked: !item.checked } : item)

        /* Check List */
        if (!list.some((item) => item.checked)) {
            return
        }

        this.setState({ operators: list })
    }

    /* Check Or Uncheck Every Operator */
    allOperators = (checked) => {

        /* Fields */
        const { operators } = this.state

        this.setState({ operators: operators.map((item) => ({ ...item, checked })) })
    }

    /* Clear The Number — the list of every round comes back at once */
    clear = () => {

        /* Fields */
        const { onNumber } = this.props

        onNumber("")
    }

    /* Submit Action */
    submit = (event) => {

        /* Fields */
        const { submit } = this.props

        /* A Form Never Reloads The Page */
        if (event) {
            event.preventDefault()
        }

        submit()
    }

    /* HOW MANY NARROWINGS THE LIST IS UNDER — THE BUTTON CARRIES THE NUMBER */
    getCount = () => {

        /* Fields */
        const { start, end, operators } = this.props

        /* Fields */
        const preset = getPreset(start, end)

        /* A Period Of No Preset Or Not The Default One */
        let count = !preset || preset.key !== "month" ? 1 : 0

        /* Operators — a narrowed list counts as one more */
        if (Array.isArray(operators) && operators.length > 0 && operators.some((item) => !item.checked)) {
            count += 1
        }

        return count
    }

    /* Draw The Search Of The Round */
    _search = () => {

        /* Fields */
        const { number, player, onNumber, onPlayer } = this.props

        return (
            <form onSubmit={this.submit} className="gf--search">

                <div className="gf--field">

                    <SearchIcon size={15} />

                    <input value={number} placeholder={t("widget.searchByNumber")} onChange={(event) => onNumber(event.target.value)} />

                    {`${number}`.trim() !== "" &&
                        <div onClick={() => this.clear()} className="gf--field-clear"><CloseIcon size={10} /></div>
                    }

                </div>

                {/* The Code Of A Player — only an electron game searches by it */}
                {onPlayer &&
                    <div className="gf--field">
                        <PlayerIcon size={15} />
                        <input value={player} placeholder={t("widget.playerID")} onChange={(event) => onPlayer(event.target.value)} />
                    </div>
                }

                <button type="submit" className="gf--submit">
                    <SearchIcon size={15} />
                    <span>{t("common.search")}</span>
                </button>

            </form>
        )
    }

    /* Draw The Tools Of The List */
    _tools = () => {

        /* Fields */
        const { status, reload, saved, onSaved, start, end, language } = this.props

        /* Fields */
        const count = this.getCount()
        const locale = language === "en" ? "en" : "ru"

        /* The open period is the hint of the button, the modal shows it in full */
        const range = `${moment(start).locale(locale).format("DD MMM YYYY")} — ${moment(end).locale(locale).format("DD MMM YYYY")}`

        return (
            <div className="gf--tools">

                {/* Reload */}
                {status === "loading"
                    ? <div className="gf--icon loading"><LoadingOutlined /></div>
                    : <div onClick={() => reload()} className="gf--icon" title={t("filter.reload")}><RefreshIcon size={16} /></div>
                }

                {/* Saved Rounds */}
                {onSaved &&
                    <div onClick={() => onSaved(!saved)} className={`gf--chip ${saved ? "active" : ""}`}>
                        <StarIcon size={14} filled={Boolean(saved)} />
                        <span>{t("widget.saved")}</span>
                    </div>
                }

                {/* The Filter Itself — the very same button every other list of the panel carries */}
                <div onClick={() => this.open()} className={`gf--filter ${count > 0 ? "active" : ""}`} title={range}>

                    <FilterIcon size={15} />

                    <span>{t("filter.title")}</span>

                    {count > 0 && <div className="gf--filter-count">{count}</div>}

                </div>

            </div>
        )
    }

    /* Draw The Period Of The Modal */
    _period = () => {

        /* Fields */
        const { language } = this.props
        const { start, end } = this.state

        /* Fields */
        const preset = getPreset(start, end)
        const locale = language === "en" ? "en" : "ru"

        return (
            <div className="gf--section">

                <div className="gf--section-head">
                    <div className="gf--section-title">
                        <CalendarIcon size={13} />
                        {t("filter.period")}
                    </div>
                </div>

                <div className="gf--presets">
                    {PRESETS.map((item) =>
                        <div
                            onClick={() => this.setPreset(item)}
                            className={`gf--preset ${preset && preset.key === item.key ? "active" : ""}`}
                            key={`${item.key}`}
                        >
                            {item.text()}
                        </div>
                    )}
                </div>

                <div className="gf--dates">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd-MM-yyyy"
                        locale={locale}
                    />

                    <span>—</span>

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd-MM-yyyy"
                        locale={locale}
                    />

                </div>

            </div>
        )
    }

    /* Draw The Operators Of The Modal */
    _operators = () => {

        /* Fields */
        const { operators } = this.state

        /* Check Operators */
        if (operators.length === 0) {
            return null
        }

        /* Fields */
        const checked = operators.filter((item) => item.checked).length

        return (
            <div className="gf--section">

                <div className="gf--section-head">

                    <div className="gf--section-title">
                        <OperatorIcon size={13} />
                        {t("filter.operators")}
                        <span className="gf--section-count">{checked}/{operators.length}</span>
                    </div>

                    <div className="gf--section-actions">
                        <span onClick={() => this.allOperators(true)}>{t("filter.selectAll")}</span>
                    </div>

                </div>

                {/* At least one operator always stays on — the list of every one of them is the whole scope */}
                <div className="gf--chips">
                    {operators.map((item, index) =>
                        <div
                            onClick={() => this.toggleOperator(index)}
                            className={`gf--chip-item ${item.checked ? "active" : ""}`}
                            key={`${item.id}`}
                        >
                            {item.checked && <CheckIcon size={10} />}
                            {item.name}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <div className="gf">

                {/* Draw Search */}
                {this._search()}

                {/* Draw Tools */}
                {this._tools()}

                <Modal
                    isOpen={visible}
                    onRequestClose={() => this.close()}
                    className="gf--modal"
                    overlayClassName="gf--overlay"
                    closeTimeoutMS={200}
                >

                    <div className="gf--modal-header">

                        <div className="gf--modal-icon">
                            <FilterIcon size={18} />
                        </div>

                        <div className="gf--modal-text">
                            <h2>{t("filter.title")}</h2>
                            <p>{t("filter.subtitle")}</p>
                        </div>

                        <div onClick={() => this.close()} className="gf--modal-close">
                            <CloseIcon size={16} />
                        </div>

                    </div>

                    <div className="gf--modal-body">

                        {/* Draw Period */}
                        {this._period()}

                        {/* Draw Operators */}
                        {this._operators()}

                    </div>

                    <div className="gf--modal-footer">
                        <div onClick={() => this.close()} className="gf--button ghost">{t("common.cancel")}</div>
                        <div onClick={() => this.apply()} className="gf--button primary">{t("filter.apply")}</div>
                    </div>

                </Modal>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(GameFilter)
